import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from '@mui/material/Alert';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import axios from "../components/Axios";
import "./Login.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: "",
      email: "",
      name: "",
      remember: false,
      success: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.login = this.login.bind(this);
  }

  componentDidMount() {
    //remember
    let r = localStorage.getItem("remember");
    if (r !== null) {
      this.setState({ email: r, remember: true });
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  rememberChange(e) {
    this.setState({ remember: e.target.checked });

    //forget
    if (!e.target.checked) {
      localStorage.removeItem("remember");
    }
  }

  login(e) {
    e.preventDefault();
    this.setState({ loading: true, errorMessage: "" });
    axios
      .post("/user/request_code", {
        name: this.state.name,
        email: this.state.email,
      })
      .then(
        function (response) {
          //this.setState({items: response.data});
          if ("error_code" in response.data) {
            this.setState({
              loading: false,
              errorMessage: response.data.message,
            });
          } else {
            this.setState({ loading: false, success: true });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          if (error.response.status === 401) {
            this.setState({ errorMessage: "Invalid email or password" });
          } else if (error.response.status === 500) {
            this.setState({ errorMessage: error.response.data.message });
          } else {
            this.setState({ errorMessage: "Unknown Error" });
          }
          this.setState({ loading: false });
        }.bind(this)
      );
    return false;
  }

  render() {
    return (
      <div
        className="background"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <NavBar />
        <Container
          maxWidth="xs"
          style={{ marginTop: "64px", flex: "1" }}
          hidden={this.state.success}
        >
          <Typography variant="h5" gutterBottom className="loginTitle">
            <Trans>Join the Beta</Trans>
          </Typography>

          <p className="loginText">
            <Trans>
              Request access below. You'll be given an invitation code by email.
            </Trans>
          </p>
          <form onSubmit={this.login}>
            <label
              htmlFor="name"
              style={{ color: "#063e6c", fontWeight: "bold" }}
            >
              <Trans>Name</Trans>
            </label>
            <br />
            <TextField
              name="name"
              id="name"
              variant="outlined"
              size="small"
              value={this.state.name}
              onChange={this.handleChange}
              fullWidth
              type="text"
            />
            <br />
            <br />
            <label
              htmlFor="email"
              style={{ color: "#063e6c", fontWeight: "bold" }}
            >
              <Trans>Email address</Trans>
            </label>
            <br />
            <TextField
              name="email"
              id="email"
              variant="outlined"
              size="small"
              value={this.state.email}
              onChange={this.handleChange}
              type="email"
              autoFocus
              fullWidth
              required
            />

            {this.state.errorMessage !== "" && (
              <Alert
                severity="error"
                onClose={() => {
                  this.setState({ errorMessage: "" });
                }}
              >
                {this.state.errorMessage}
              </Alert>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "32px 0",
              }}
            >
              <div></div>
              <Button
                className="Button ButtonPrimary"
                size="small"
                type="submit"
                disabled={this.state.loading}
              >
                <Trans>Submit</Trans>
              </Button>
            </div>
          </form>
        </Container>
        <Container
          maxWidth="xs"
          style={{ marginTop: "64px", flex: "1" }}
          hidden={!this.state.success}
        >
          <Typography variant="h5" gutterBottom className="loginTitle">
            <Trans>Thank you!</Trans>
          </Typography>
          <p className="loginText">
            <Trans>
              We will contact you by email with the invitation code once
              approved.
            </Trans>
          </p>
        </Container>
        <Footer></Footer>
      </div>
    );
  }
}

export default withRouter(Index);
